#import "./availabilityOverrideInfo.gql"

query GetAvailabilityOverrides($startDate: ISO8601Date!, $endDate: ISO8601Date!) {
  availabilityOverrides(startDate: $startDate, endDate: $endDate) {
    ...availabilityOverrideInfo
  }
}

mutation UpdateAvailabilityOverrides(
  $startDate: ISO8601Date!
  $endDate: ISO8601Date!
  $availabilityOverrides: [AvailabilityOverridesInput!]!
) {
  updateAvailabilityOverrides(startDate: $startDate, endDate: $endDate, availabilityOverrides: $availabilityOverrides) {
    availabilityOverrides {
      ...availabilityOverrideInfo
    }
  }
}
